import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';
import axios from '../Config/axiosConfig';

//Compartilhados
import CustomModal from '../Shared/CustomJs/CustomModal';
import SearchBar from '../Shared/CustomJs/SearchBar';
import CustomTable from '../Shared/CustomJs/CustomTable';
import CustomPagination from '../Shared/CustomJs/CustomPagination';
import Loading from '../Shared/Loading/Loading';
import CustomFooter from '../Shared/CustomJs/CustomFooter';

//
import './../Shared/sharedStyles.css';
import { formatarDataComHora } from './../Shared/Utils/helper';

// Definindo as classes CSS
const styles = ` 
  .custom-select {
    appearance: auto; // Adicione esta linha para restaurar a aparência padrão do <select>
  }
`;
const baseApiUrl = process.env.REACT_APP_API_URL;
const baseApi = `${baseApiUrl}/api/DocumentosComplementares`

const DocumentosComplementares = () => {

    const listOptions = [
        { value: "tipoDocumento", label: "Tipo de Documento" },
        { value: "descricao", label: "Descrição" },
        { value: "cadastradoPor", label: "Cadastrado Por" },
        { value: "dataCadastro", label: "Data Cadastro" },
        { value: "alteradoPor", label: "Alterado Por" },
        { value: "dataAlteracao", label: "Data Alteração" },
    ];

    const excludeColumns = ["idDocumentosComp", "ativo"]; // Colunas que você quer excluir da tabela

    const renderTableHeaders = () => {
        const emptyColumns = [<th key="empty1"></th>, <th key="empty2"></th>];

        const optionColumns = listOptions.map((option, index) => (
            <th key={index}>{option.label}</th>
        ));

        return [...emptyColumns, ...optionColumns];
    };

    const [loading, setLoading] = useState(true);

    const itemsPerPage = 50; // Número de itens por página

    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);

    const [listDocumentosComplementaresData, setListDocumentosComplementaresData] = useState([]);
    const [constListData, setConstListData] = useState([]);

    //Add
    const [newTipoDocumento, setNewTipoDocumento] = useState('');
    const [newDescricao, setNewDescricao] = useState('');

    //Edit
    const [editTipoDocumento, setEditTipoDocumento] = useState(null);
    const [editDescricao, setEditDescricao] = useState(null);

    const [idDocumentosComp, setIdDocumentosComp] = useState(null);

    const [modalMessage, setModalMessage] = useState('');
    const itemInputRef = useRef(null);

    const [selectedOption, setSelectedOption] = useState("tipoDocumento");

    // No react 18 é necessário para não chamar 2 vezes a API
    const initialized = useRef(false);

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;

            fetchInitialData();
        }
    }, []);

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            setSearchTerm('');
            const response = await axios.get(`${baseApi}/get-documentos-complementares`);
            const formattedData = formatarDataComHora(response.data);
            setListDocumentosComplementaresData(formattedData);
            setConstListData(formattedData);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
        setLoading(false);
    };

    const handleSave = async (tipodocumento, descricao) => {
        if (
            !tipodocumento?.trim() ||
            !descricao?.trim()
        ) {
            setModalMessage('Erro ao adicionar o registro: É obrigatório preecher todos os campos com *');
            return;
        }

        const itemExists = listDocumentosComplementaresData.some((item) => item.tipodocumento && item.tipodocumento.toLowerCase() === tipodocumento.toLowerCase());
        if (itemExists) {
            setModalMessage(`Registro ${tipodocumento} já existe`);
        } else {
            setLoading(true);
            try {
                const newItem = {
                    TipoDocumento: tipodocumento,
                    Descricao: descricao
                };

                const response = await axios.post(`${baseApi}/add-documento-complementar`, newItem);

                if (response?.status === 200) {
                    setModalMessage(`${response?.data?.message}`);

                    if (!(response?.data?.message.toLowerCase().includes('erro')
                        || response?.data?.message.toLowerCase().includes('existe'))
                    ) {
                        setNewTipoDocumento('');
                        setNewDescricao('');
                        setEditTipoDocumento(null);
                        setEditDescricao(null);
                        fetchInitialData();
                    }

                } else {
                    setTimeout(() => {
                        setLoading(false);
                    }, 1);
                    console.error('Erro ao adicionar o acessório:', response?.data?.message);
                    setModalMessage(`Erro ao adicionar o registro: ${response?.data?.message}`);
                }
            } catch (error) {
                console.error('Erro ao adicionar o acessório:', error?.response?.data?.errors[0]);
                setModalMessage(`Erro ao adicionar o registro: ${error?.response?.data?.errors[0]}`);
                //setModalMessage(`Erro ao adicionar o registro: ${error.response.data.errors[0]}`);
            }
            setTimeout(() => {
                setLoading(false);
            }, 1);
        }
    };

    const handleUpdate = async (tipodocumento, descricao) => {

        if (
            !tipodocumento?.trim() ||
            !descricao?.trim()
        ) {
            setModalMessage('Erro ao editar o registro: É obrigatório preecher todos os campos com *');
            return;
        }

        const itemExists = listDocumentosComplementaresData.some((item) => item.tipodocumento && item.tipodocumento.toLowerCase() === tipodocumento.toLowerCase());
        if (itemExists) {
            setModalMessage(`Registro ${tipodocumento} já existe`);
        } else {
            setLoading(true);

            try {

                const newItem = {
                    TipoDocumento: tipodocumento,
                    Descricao: descricao
                };

                const response = await axios.put(`${baseApi}/update-documento-complementar/${idDocumentosComp}`, newItem);

                if (response?.status === 200) {
                    setModalMessage(`${response.data.message}`);

                    if (!(response?.data?.message.toLowerCase().includes('erro')
                        || response?.data?.message.toLowerCase().includes('existe'))
                    ) {
                        setNewTipoDocumento('');
                        setNewDescricao('');
                        setEditTipoDocumento(null);
                        setEditDescricao(null);
                        setShowModal(false);
                        Swal.fire('Atualizado!', `${response?.data?.message}`, 'success');
                        setTimeout(() => {
                            fetchInitialData();
                        }, 50);
                    }
                    setTimeout(() => {
                        setLoading(false);
                    }, 1);
                } else {
                    setTimeout(() => {
                        setLoading(false);
                    }, 1);
                    console.error('Erro ao editar o acessório:', response?.data?.message);
                    setModalMessage(`Erro ao editar o registro: ${response?.data?.message}`);
                }
            } catch (error) {
                setTimeout(() => {
                    setLoading(false);
                }, 1);
                console.error('Erro ao editar o acessório:', error?.response?.data?.errors[0]);
                setModalMessage(`Erro ao editar o registro: ${error?.response?.data?.errors[0]}`);
            }
            setTimeout(() => {
                setLoading(false);
            }, 1);

        }
    };

    const handleDelete = async (item) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: 'Você tem certeza que deseja excluir esse registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, deletar!',
            cancelButtonText: 'Não, cancelar!',
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.delete(`${baseApi}/delete-documento-complementar/${item.idDocumentosComp}`);
                    if (response?.status === 200) {
                        Swal.fire('Deletado!', `${response?.data?.message}`, 'success').then(async () => {
                            fetchInitialData();
                        });

                    } else {
                        console.error('Erro ao deletar o registro:', response?.data?.message);
                    }
                } catch (error) {
                    console.error('Erro ao deletar o registro:', error?.response?.data?.errors[0]);
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelado', 'Seu registro está seguro :)', 'error');
            }
        });
    };

    const handleChangeSearchTerm = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleSearchClick = () => {
        const searchInput = document.getElementById("pesquisarId");
        setSearchTerm(searchInput.value);
    };

    const handleTipoDocumentoChange = (event) => {
        isUpdate
            ? setEditTipoDocumento(event.target.value.toUpperCase())
            : setNewTipoDocumento(event.target.value.toUpperCase());
    };

    const handleDescricaoChange = (event) => {
        isUpdate
            ? setEditDescricao(event.target.value.toUpperCase())
            : setNewDescricao(event.target.value.toUpperCase());
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const filteredDocumentosComplementaresData = constListData.filter((item) =>
        item[selectedOption].toString().toLowerCase().includes(searchTerm.toLowerCase())
    );

    const paginatedData = filteredDocumentosComplementaresData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const totalPages = Math.ceil(filteredDocumentosComplementaresData.length / itemsPerPage);
    const totalRecords = filteredDocumentosComplementaresData.length;

    const openModalAdd = () => {
        setModalMessage('');
        setNewTipoDocumento('');
        setNewDescricao('');
        setIdDocumentosComp(null);
        setEditDescricao(null);
        setEditTipoDocumento(null);
        setIsUpdate(false);
        setShowModal(true);
    };
    const openModalEdit = (item) => {
        setModalMessage('');
        setEditTipoDocumento(item.tipoDocumento);
        setEditDescricao(item.descricao);
        setIdDocumentosComp(item.idDocumentosComp);
        setNewTipoDocumento('');
        setNewDescricao('');
        setIsUpdate(true);
        setShowModal(true);
    };
    const closeModal = () => {
        setModalMessage('');
        setNewTipoDocumento('');
        setNewDescricao('');
        setIdDocumentosComp(null);
        setEditDescricao(null);
        setIdDocumentosComp(null);
        setIsUpdate(false);
        setShowModal(false);
    };

    if (loading) {
        return <Loading />;
    }
    if (constListData.length <= 0) {
        return (
            <Container fluid>
                <style>{styles}</style>
                <Row className='mt-3'>
                    <Col>
                        <Form>
                            <Row className='mt-3'>
                                <Col>
                                    <h4 style={{ color: 'red' }}>Documentos Complementares</h4>
                                </Col>
                            </Row>
                            <div style={{ display: 'flex', height: 'calc(100vh - 200px)', justifyContent: 'center', alignItems: 'center' }}>
                                <h1 style={{ fontSize: '3em' }}>Nenhum registro encontrado</h1>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
    return (
        <Container fluid>
            <style>{styles}</style>
            <Row className='mt-3'>
                <Col>
                    <Form>
                        <Card>
                            <Card.Header className='title-card-custom'><h4>Documentos Complementares</h4></Card.Header>
                            <Card.Body>
                                <SearchBar
                                    listOptions={listOptions}
                                    handleChangeSearchTerm={handleChangeSearchTerm}
                                    handleSelectChange={handleSelectChange}
                                    handleSearchClick={handleSearchClick}
                                    openModal={openModalAdd}
                                    fetchInitialData={fetchInitialData}
                                />
                                <CustomTable
                                    renderTableHeaders={renderTableHeaders}
                                    data={paginatedData}
                                    handleEdit={openModalEdit}
                                    handleDelete={handleDelete}
                                    excludeColumns={excludeColumns}
                                />

                                <CustomPagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                                <CustomFooter currentPage={currentPage} totalPages={totalPages} totalRecords={totalRecords} />
                            </Card.Body>
                        </Card>
                    </Form>
                </Col>
            </Row>

            <CustomModal
                show={showModal}
                onHide={closeModal}
                title={isUpdate ? 'Doc. Compl. - Editar' : 'Doc. Compl. - Incluir'}
                onSave={isUpdate
                    ? () => handleUpdate(editTipoDocumento, editDescricao)
                    : () => handleSave(newTipoDocumento, newDescricao)}
                saveButtonText={isUpdate ? 'Atualizar' : 'Incluir'}
            >
                <Form.Group controlId="tipodocumento">
                    <Form.Label className="bold-label">*Tipo de documento:</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Digite o tipo de documento"
                        autoFocus
                        value={isUpdate
                            ? editTipoDocumento
                            : newTipoDocumento}
                        onChange={handleTipoDocumentoChange}
                    />
                </Form.Group>
                <Form.Group controlId="descricao" className='mt-3'>
                    <Form.Label className="bold-label">*Descrição:</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Digite a descrição"
                        value={isUpdate
                            ? editDescricao
                            : newDescricao}
                        onChange={handleDescricaoChange}
                    />
                </Form.Group>

                {modalMessage && (
                    <p style={{ color: modalMessage.startsWith(`Erro`) ? 'red' : 'green' }}>
                        {modalMessage}
                    </p>
                )}
            </CustomModal>
        </Container>
    )
};

export default DocumentosComplementares;

